module.exports = __webpack_public_path__ + "img/red-bullet.01608f17.svg";